import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar, Dialog, DialogContent, FormControlLabel, Checkbox } from "@mui/material";
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';
import logo_icon from '../../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { RedirectPageData } from "../../../utils/static-data/index.js";
import { CrossSvg, UploadImageSvg } from "../../../assets/svg/index.js";
import { CloseRounded } from "@mui/icons-material";
import { api_urls } from "../../../utils/api-urls/index.js";

const AddProduct = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const stateData = location.state && location.state.stateData;
  useEffect(() => {
    console.log("State Data ::: ", stateData);
  }, [])

  const { ecommerceCategoryData, ecommerceSubCategoryByCategoryIdData, ecommerceAttributeData } = useSelector(state => state.ecommerceReducer);

  const [modalVisible, setModalVisible] = useState(false)
  const [productDetail, setProductDetail] = useState({ categoryId: stateData ? stateData?.productCategoryId : '', subCategoryId: stateData ? stateData?.productSubCategoryId : '', productName: stateData ? stateData?.title : '', description: stateData ? stateData?.description : '', mrp: stateData ? stateData?.mrp : '', currentPrice: stateData ? stateData?.current_price : '', purchasePrice: stateData ? stateData?.purchased_price : '', tags: stateData ? 'Tag1, Tag2' : '' });
  const [inputFieldError, setInputFieldError] = useState({ categoryId: '', subCategoryId: '', productName: '', description: '', mrp: '', currentPrice: '', purchasePrice: '', tags: '', image: '' });
  const [image, setImage] = useState({ file: stateData ? api_urls + stateData?.image : '', bytes: '' });
  const [bulkImage, setBulkImage] = useState(stateData ? stateData?.bulk_image.map(value => { return { file: api_urls + value, bytes: '' } }) : []); //* Mutliple File 

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setProductDetail({ ...productDetail, [name]: value });
  };

  // Handle Image :  //! Normally
  const handleImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  // Handle Image :  //! Drop Feature
  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      setImage({
        file: URL.createObjectURL(e.dataTransfer.files[0]),
        bytes: e.dataTransfer.files[0],
      });
    }

    handleInputFieldError("image", null)
  };

  // Handle Image :  //! Bulk Image
  const handleBulkImage = (e) => {
    // console.log("Bulk Image length :: ", bulkImage?.length + 1)
    if (bulkImage.length + 1 <= 10) {
      setBulkImage([...bulkImage, {
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      }]);
    } else {
      alert('You have cross your limit bugger')
    }
  }

  //Todo : Attribute | Inventory Feature Start
  const [selectedAttributes, setSelectedAttributes] = useState({});
  const handleCheckboxChange = (attributeId, valueIndex, valueLabel) => {
    setSelectedAttributes(prevState => {
      const attributeValues = prevState[attributeId] || [];
      if (attributeValues.some(v => v.index === valueIndex)) {
        return {
          ...prevState,
          [attributeId]: attributeValues.filter(v => v.index !== valueIndex),
        };
      } else {
        return {
          ...prevState,
          [attributeId]: [...attributeValues, { index: valueIndex, label: valueLabel }],
        };
      }
    });
  };

  const generateCombinations = () => {
    // console.log("Selected Attributes:: ", selectedAttributes)
    // console.log(Object.values(selectedAttributes))
    // const selectedValues = Object.values(selectedAttributes).filter(arr => arr.length > 0);

    const selectedValues = Object.keys(selectedAttributes).map(key => {
      return selectedAttributes[key].map(item => ({
        ...item,
        parentKey: key
      }));
    });

    if (selectedValues.length === 0) return [];

    const combine = (arr) => {
      if (arr.length === 1) return arr[0].map(val => [val]);

      const [first, ...rest] = arr;
      const restCombinations = combine(rest);
      return first.flatMap(val => restCombinations.map(combination => {
        return [val, ...combination]
      }));
    };

    return combine(selectedValues);
  };

  const combinations = generateCombinations();

  const [combineAttribute, setCombineAttribute] = useState([]);
  const [currentIndex, setCurrentIndex] = useState([]);

  const handleAddCombination = (combination, index) => {
    if (!currentIndex.includes(index)) {
      setCurrentIndex(prev => [...prev, index]);
      setCombineAttribute(prevCombineAttribute => [...prevCombineAttribute, combination]);
    }

    // setCombineAttribute((prevCombineAttribute) => {
    //   // Check if the combination with the same index is already in the state
    //   const isDuplicate = prevCombineAttribute.some((item) => item.index === combination.index);

    //   if (isDuplicate) {
    //     return prevCombineAttribute; // Return previous state if duplicate
    //   } else {
    //     return [...prevCombineAttribute, combination]; // Add new combination
    //   }
    // });
  };

  const [productAttributesData, setProductAttributesData] = useState([{}]);
  const handleInputProductAttributesData = (index, field, value, details) => {
    const newproductAttributesData = [...productAttributesData];
    newproductAttributesData[index] = {
      ...newproductAttributesData[index], // Create a copy of the object at the given index
      [field]: value,
      added_attribute: JSON.stringify(details)
    };
    setProductAttributesData(newproductAttributesData);
  };

  //Todo : Attribute | Inventory Feature End

  //* Handle Validation
  const handleValidation = () => {
    let isValid = true;
    const { categoryId, subCategoryId, productName } = productDetail;
    const { bytes } = image;

    if (!categoryId) {
      handleInputFieldError("categoryId", "Please Select Category Name")
      isValid = false;
    }
    if (!subCategoryId) {
      handleInputFieldError("subCategoryId", "Please Select Sub Category Name")
      isValid = false;
    }
    if (!productName) {
      handleInputFieldError("productName", "Please Enter Sub Category Name")
      isValid = false;
    }
    if (!bytes) {
      handleInputFieldError("image", "Please Select Image")
      isValid = false;
    }
    return isValid;
  };

  //! Handle Submit - Creating Ecommerce Product
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Product Data :: ", { ...productDetail, image, bulkImage: bulkImage?.map((value) => value?.bytes), productAttributesData })
    const bulkImageArray = bulkImage?.map((value) => value?.bytes);

    const { categoryId, subCategoryId, productName, description, purchasePrice, mrp, currentPrice, tags } = productDetail;

    if (stateData) {
      let formData = new FormData();
      formData.append("productId", stateData?._id);
      formData.append("productCategoryId", categoryId);
      formData.append("productSubCategoryId", subCategoryId);
      formData.append("title", productName);
      formData.append("description", description);
      formData.append("mrp", mrp);
      formData.append("current_price", currentPrice);
      formData.append("purchased_price", purchasePrice);
      formData.append("tags", tags);
      formData.append("image", image?.bytes);
      bulkImageArray.map((value, index) => (
        formData.append(`bulkImages`, value)
      ))
      productAttributesData.map((value, index) => {
        formData.append(`attributes_inventory[${index}][added_attribute]`, value?.added_attribute)
        formData.append(`attributes_inventory[${index}][quantity]`, value?.quantity)
        formData.append(`attributes_inventory[${index}][inventory]`, value?.inventory)
      })

      const payload = {
        data: formData,
        onComplete: () => navigate('/e-commerce/product')
      }

      //! Dispatching API for Updating Products
      dispatch(EcommerceActions.updateEcommerceProduct(payload))

    } else {
      let formData = new FormData();
      formData.append("productCategoryId", categoryId);
      formData.append("productSubCategoryId", subCategoryId);
      formData.append("title", productName);
      formData.append("description", description);
      formData.append("mrp", mrp);
      formData.append("current_price", currentPrice);
      formData.append("purchased_price", purchasePrice);
      formData.append("tags", tags);
      formData.append("image", image?.bytes);
      bulkImageArray.map((value, index) => (
        formData.append(`bulkImages`, value)
      ))
      productAttributesData.map((value, index) => {
        formData.append(`attributes_inventory[${index}][added_attribute]`, value?.added_attribute)
        formData.append(`attributes_inventory[${index}][quantity]`, value?.quantity)
        formData.append(`attributes_inventory[${index}][inventory]`, value?.inventory)
      })

      const payload = {
        data: formData,
        onComplete: () => navigate('/e-commerce/product')
      }

      //! Dispatching API for Creating Products
      dispatch(EcommerceActions.createEcommerceProduct(payload))
    }
  };

  useEffect(() => {
    //! Dispatching API for Getting Ecommerce Category
    dispatch(EcommerceActions.getEcommerceCategory())

    //! Dispatching API for Getting Ecommerce Attribute
    dispatch(EcommerceActions.getEcommerceAttribute())
  }, []);

  useEffect(() => {
    //! Dispatching API for Getting Ecommerce Sub Category By Category Id
    productDetail?.categoryId && dispatch(EcommerceActions.getEcommerceSubCategoryByCategoryId({ productCategoryId: productDetail?.categoryId }))

    setProductDetail({ ...productDetail, subCategoryId: '' }) //* Clearing Sub Category as Category is changing
  }, [productDetail?.categoryId]);

  return (
    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add Product</div>
          <div onClick={() => navigate("/e-commerce/product")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={12} sm={12} md={12} xs={12} >
            <div style={{ color: "#000", border: "1px solid #C4C4C4", borderRadius: "3px" }}>
              {image?.bytes || image?.file ?
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px", cursor: "pointer" }}>
                  <Avatar src={image.file} style={{ height: '300px', width: "300px", borderRadius: "initial" }} />
                </label>
                :
                <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-image" style={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center", padding: "100px 0", cursor: "pointer" }}>
                  <UploadImageSvg h="80" w="80" color="#C4C4C4" />
                  <div style={{ fontWeight: "600", fontSize: "18px" }}>Choose Your Image to Upload</div>
                  <div style={{ fontWeight: "500", fontSize: "16px", color: 'grey' }}>Or Drop Your Image Here</div>
                </label>}
              <input id="upload-image" onChange={handleImage} hidden accept="image/*" type="file" />
            </div>
            {inputFieldError?.image && <div style={{ color: "#D32F2F", fontSize: "10.75px", padding: "10px 0 0 12px", }}>{inputFieldError?.image}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Category Name</InputLabel>
              <Select
                label="Select Category Name" variant="outlined" fullWidth
                name='categoryId'
                value={productDetail?.categoryId}
                onChange={handleInputField}
                error={inputFieldError?.categoryId ? true : false}
                onFocus={() => handleInputFieldError("categoryId", null)}
              >
                <MenuItem disabled>---Select Category Name---</MenuItem>
                {ecommerceCategoryData.map((value, index) => {
                  return <MenuItem key={index} value={value?._id}>{value?.title}</MenuItem>
                })}
              </Select>
            </FormControl>
            {inputFieldError?.categoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.categoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Sub Category</InputLabel>
              <Select
                label="Select Sub Category" variant="outlined" fullWidth
                name='subCategoryId'
                value={productDetail?.subCategoryId}
                onChange={handleInputField}
                error={inputFieldError?.subCategoryId ? true : false}
                onFocus={() => handleInputFieldError("subCategoryId", null)}
              >
                {ecommerceSubCategoryByCategoryIdData.length == 0 ? <MenuItem disabled>---Please First Select category---</MenuItem> : <MenuItem disabled>---Select Sub Category---</MenuItem>}
                {ecommerceSubCategoryByCategoryIdData && ecommerceSubCategoryByCategoryIdData.length == 0 ? <MenuItem disabled>You don't have Sub category</MenuItem> : ecommerceSubCategoryByCategoryIdData?.map(value => (<MenuItem key={value?._id} value={value?._id}>{value?.product_sub_category_name}</MenuItem>))}
              </Select>
            </FormControl>
            {inputFieldError?.subCategoryId && <div style={{ color: "#D32F2F", fontSize: "10px", padding: "3px 15px 0 15px" }}>{inputFieldError?.subCategoryId}</div>}
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Product Name" variant='outlined' fullWidth
              name='productName'
              value={productDetail?.productName}
              onChange={handleInputField}
              error={inputFieldError.productName ? true : false}
              helperText={inputFieldError.productName}
              onFocus={() => handleInputFieldError("productName", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="MRP" variant='outlined' fullWidth
              name='mrp'
              value={productDetail?.mrp}
              onChange={handleInputField}
              error={inputFieldError.mrp ? true : false}
              helperText={inputFieldError.mrp}
              onFocus={() => handleInputFieldError("mrp", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Current Price" variant='outlined' fullWidth
              name='currentPrice'
              value={productDetail?.currentPrice}
              onChange={handleInputField}
              error={inputFieldError.currentPrice ? true : false}
              helperText={inputFieldError.currentPrice}
              onFocus={() => handleInputFieldError("currentPrice", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Purchase Price" variant='outlined' fullWidth
              name='purchasePrice'
              value={productDetail?.purchasePrice}
              onChange={handleInputField}
              error={inputFieldError.purchasePrice ? true : false}
              helperText={inputFieldError.purchasePrice}
              onFocus={() => handleInputFieldError("purchasePrice", null)}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <label style={{ color: "#000", marginBottom: "#000", fontSize: "14.5px", color: "grey" }}>Description</label>
              <textarea
                name='description'
                value={productDetail?.description}
                onChange={handleInputField}
                placeholder="Description"
                rows={8}
                onFocus={() => handleInputFieldError("description", null)}
                style={{ minWidth: "100%", maxWidth: "100%", minHeight: "50px", padding: "10px", outline: "none", border: "1px solid #C4C4C4", borderRadius: "3.5px", fontFamily: "Philosopher" }}
              />
            </div>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <label style={{ color: "#000", marginBottom: "#000", fontSize: "14.5px", color: "grey" }}>Tags</label>
              <textarea
                name='tags'
                value={productDetail?.tags}
                onChange={handleInputField}
                placeholder="men, men shirts, shirts"
                rows={8}
                onFocus={() => handleInputFieldError("tags", null)}
                style={{ minWidth: "100%", maxWidth: "100%", minHeight: "50px", padding: "10px", outline: "none", border: "1px solid #C4C4C4", borderRadius: "3.5px", fontFamily: "Philosopher" }}
              />
            </div>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ color: "#000" }}>
            <div style={{ display: "flex", gap: "40px", flexWrap: "wrap", justifyContent: "space-evenly", marginBottom: "20px" }}>
              {bulkImage.length > 0 && bulkImage?.map((value, index) => (
                <div key={index} style={{ position: "relative" }}>
                  <Avatar src={value.file} style={{ height: '150px', width: "250px", borderRadius: "initial" }} />
                  <div onClick={() => setBulkImage(bulkImage.filter((curr, currIndex) => currIndex !== index))} style={{ position: "absolute", top: '-13px', right: '-15px', cursor: "pointer" }}><CrossSvg /></div>
                </div>
              ))}
            </div>

            <div style={{ textAlign: "center", marginBottom: "10px", fontSize: "13px", color: "gray" }}>Upload More Images(Max File Count : 10)</div>
            <label onDragOver={(e) => e.preventDefault()} onDrop={handleDrop} htmlFor="upload-bulk-image" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "25px", cursor: "pointer", border: "1px solid #C4C4C4", borderRadius: "3.5px", padding: "5px 0", backgroundColor: "#F1F1F7" }}>
              <UploadImageSvg h="25" w="25" color="#000" />
              <div style={{ fontWeight: "600", fontSize: "15px" }}>Upload</div>
            </label>
            <input id="upload-bulk-image" multiple type="file" onChange={handleBulkImage} hidden />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ color: "#000" }}>
            <div onClick={() => setModalVisible(true)} style={{ textAlign: "end", fontWeight: "600", fontSize: "14.5px", cursor: "pointer" }}>+ Add Attribute</div>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ color: "grey", fontSize: "16px" }}>
            <ul style={{ display: "flex", flexDirection: "column", gap: "15px", padding: "20px 0 20px 50px" }}>
              {combinations && combinations.map((combination, index) => (
                <li key={index} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <label htmlFor={`combination-item-${index}`} style={{ cursor: 'pointer', paddingLeft: "15px", display: "flex", alignItems: "center" }}>{combination.map(item => item.label).join(' + ')}</label>
                  <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <input style={{ outline: "none", width: "50px", padding: "5px", border: "1px solid #C4C4C4", borderRadius: "3px" }} type="text"
                      // name={productAttributesData[index]?.quantity}
                      value={productAttributesData[index]?.quantity}
                      onChange={(e) => handleInputProductAttributesData(index, 'quantity', e.target.value, combination)}
                    />
                    <input style={{ outline: "none", width: "50px", padding: "5px", border: "1px solid #C4C4C4", borderRadius: "3px" }} type="text"
                      // name={productAttributesData[index]?.inventory}
                      value={productAttributesData[index]?.inventory}
                      onChange={(e) => handleInputProductAttributesData(index, 'inventory', e.target.value, combination)}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container sx={{ justifyContent: "space-between" }}>
              <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Dialog open={modalVisible}>
        <div style={{ minWidth: "350px", fontSize: "14.5px" }}>
          <div style={{ borderBottom: "1px solid #cfcfcf", padding: "20px" }}>
            <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
              <div style={{ fontSize: "20px", fontWeight: "600" }}>Attribute</div>
              <div onClick={() => {
                setModalVisible(false)
                // setSelectedAttributes({})
              }}><CloseRounded /></div>
            </div>
          </div>

          <div style={{ padding: "25px 20px", display: "flex", flexDirection: "column", gap: "25px", borderBottom: "1px solid #cfcfcf" }}>
            {ecommerceAttributeData?.map((attribute) => (
              <div key={attribute?._id} style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flexBasis: "20%" }}>{attribute?.title}</div>

                {attribute?.values?.map((value, index) => (
                  <div style={{ flexBasis: "25%", display: "flex", alignItems: "center" }} key={value}>
                    <input
                      checked={selectedAttributes[attribute._id]?.some(v => v.index === index) || false}
                      onChange={() => handleCheckboxChange(attribute._id, index, value)}
                      id={`${value}-${index}`} type="checkbox" style={{ padding: 0, margin: 0, cursor: "pointer" }} />
                    <label htmlFor={`${value}-${index}`} style={{ cursor: "pointer", paddingLeft: "5px" }}>{value}</label>
                  </div>
                ))}
              </div>
            ))}
          </div>

          {/* <div style={{ padding: "20px" }}>
            <h3 style={{ marginBottom: "15px" }}>Combinations:</h3>
            <ul style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
              {combinations.map((combination, index) => (
                <li key={index} onClick={() => handleAddCombination(combination, index)} style={{ display: "flex", alignItems: "center" }}>
                  <input id={`combination-item-${index}`} type="checkbox" style={{ cursor: 'pointer', margin: 0, padding: 0 }} /> <label htmlFor={`combination-item-${index}`} style={{ cursor: 'pointer', paddingLeft: "15px" }}>{combination.map(item => item.label).join(', ')}</label>
                </li>
              ))}
            </ul>
          </div> */}
        </div>
      </Dialog>
    </>
  );
};

export default AddProduct;